import {throwEvent} from '../../../../shared/utils/event-manager';

$('[data-track]').each((i, link) => {
  const $link = $(link);
  $link.click(() => {
    throwEvent($link.data('track'), $link.data('track-props'));
  });
});
